<div class="panel" [header]="header" sticky [activeTab]="order.discount>0">
  <div class="panel-heading">
    <div class="row">
      <div class="col-xs-4">
        <span>
          <i class="flaticon-shopping-cart-of-checkered-design"></i>
          <span *ngIf="elementsNbr>0 && updatePanier">( {{elementsNbr}} )</span>
        </span>
      </div>
      <div class="col-xs-8 text-right" *ngIf="updatePanier && elementsNbr>0">
        <i class="flaticon-garbage" (click)="clear()"></i>
      </div>
    </div>
  </div>
  <div class="panel-body">
    <div class="ibox-content no-padding">
      <div class="element" *ngFor="let el of order?.elements;let i=index">
        <table style="width: 100%">
          <tr valign="middle">
            <td style="padding:2px;width:30px">
              <div class="quantity-bloc">
                <button *ngIf="updatePanier" class="more btn-quantity icon-plus" (click)="incrQty(i,0)">+</button>
                <span>{{el.qty}}x</span>
                <button *ngIf="updatePanier" class="less btn-quantity icon-minus" (click)="decrQty(i,0)">-</button>
              </div>
            </td>
            <td style="padding:2px;">
              <span *ngIf="order.displayCode && el.code!=''">{{el.code}}-</span>{{el.name}}  {{el.priceWithSupp | number : '1.2-2'}} €
              <span class="d-block size">{{el.size.size}}</span>
            </td>
            <td style="padding:2px;" class="remove">
              <i class="flaticon-edit-document" *ngIf="updatePanier && el.canUpdate" role="button"
                (click)="updateElement(i)"></i>
              <i class="flaticon-cross-out" *ngIf="updatePanier" role="button" (click)="removeElement(i,0)"></i>
            </td>
          </tr>
          <tr valign="top" *ngIf="el.removedCompositions?.length>0">
            <td>
              <span class="ingTitle">sans :</span>
            </td>
            <td class="ing">
              <p>
                <span class="d-block" *ngFor="let comp of el.removedCompositions">{{comp.text}}, </span>
              </p>
              <hr>
            </td>
            <td></td>
          </tr>
          <tr valign="top" *ngIf="el.optionIngredients?.length>0">
            <td>
              <span class="ingTitle">avec :</span>
            </td>
            <td class="ing">
              <p>
                <span class="d-block" *ngFor="let opt of el.optionIngredients">{{opt.text}}, </span>
              </p>
              <hr>
            </td>
            <td></td>
          </tr>
          <tr valign="top" *ngIf="el.supplements?.length>0">
            <td>
              <span class="ingTitle">supp :</span>
            </td>
            <td class="ing">
              <p>
                <span class="d-block" *ngFor="let supp of el.supplements">{{supp.text}} ( {{supp.price}} € ), </span>
              </p>
            </td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">{{el.comment}}</td>
          </tr>
        </table>
        <div class="row total">
          <div class="col-xs-offset-8 col-xs-4 text-right">
            <div>{{el.total | number : '1.2-2'}}€</div>
          </div>
        </div>
      </div>
      <div class="element" *ngFor="let menu of order?.menus;let i=index">
        <table style="width: 100%">
          <tr valign="middle">
            <td style="padding:2px;width:30px">
              <div class="quantity-bloc">
                <span>{{menu.qty}}x</span>
              </div>
            </td>
            <td style="padding:2px;">
              <span *ngIf="order.displayCode && menu.code!=''">{{menu.code}}-</span>{{menu.title}}
              <span *ngIf="menu.offer==null">{{menu.priceWithSupp | number : '1.2-2'}} €</span>
            </td>
            <td style="padding:2px;" class="remove">
              <i class="flaticon-cross-out" *ngIf="updatePanier" role="button" (click)="removeElement(i,1)"></i>
            </td>
          </tr>
          <tr>
            <td></td>
            <td class="ing">
              <ul style="padding-left: 24px;font-size: 10px;">
                <li *ngFor="let el of menu?.elements;let i=index">
                  <ng-container *ngIf="el.qty>1">{{el.qty}}x</ng-container> {{el.name}}
                  <span *ngIf="el.size.level>0">({{el.size.label}} <span
                      *ngIf="el.priceSuppMenu && el.priceSuppMenu>0">Supp {{el.priceSuppMenu}} €</span> )</span>
                  <p *ngIf="el.removedCompositions?.length>0">
                    <span class="ingTitle">sans :</span>
                    <span class="d-block" *ngFor="let opt of el.removedCompositions">{{opt.text}}, </span>
                  </p>
                  <hr *ngIf="el.removedCompositions?.length>0">
                  <p *ngIf="el.optionIngredients?.length>0">
                    <span class="ingTitle">avec :</span>
                    <span class="d-block" *ngFor="let opt of el.optionIngredients">{{opt.text}}, </span>
                  </p>
                  <hr *ngIf="el.optionIngredients?.length>0">
                  <p *ngIf="el.supplements?.length>0">
                    <span class="ingTitle">supp :</span>
                    <span class="d-block" *ngFor="let opt of el.supplements">{{opt.text}} ( {{opt.price}} €), </span>
                  </p>
                </li>
                <li *ngFor="let el of menu?.additionalOptions">
                  {{el.name}} ({{el.size}} {{el.price}} €)
                </li>
              </ul>
            </td>
            <td></td>
          </tr>
          <tr>
            <td></td>
            <td colspan="2">{{menu.comment}}</td>
          </tr>
        </table>
        <div class="row total">
          <div class="col-xs-offset-8 col-xs-4 text-right">
            <span>{{menu.total | number : '1.2-2'}}€</span>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between" *ngIf="order.discount>0 || order.coupon>0 ||order.fees>0">
        <p>
          <b>Sous-total :</b>
        </p>
        <div>
          {{order.amount | number : '1.2-2'}} €
        </div>
      </div>
      <div class="d-flex justify-content-between" *ngIf="order.discount>0">
        <p>
          <b>Remise {{order.discount}}% :</b>
        </p>
        <div>
          {{order.discountValue | number : '1.2-2'}} €
        </div>
      </div>
      <div class="d-flex justify-content-between" *ngIf="order.coupon>0">
        <p>
          <b>Coupon {{order.coupon}} <ng-container *ngIf="order.couponType==1">€</ng-container>
            <ng-container *ngIf="order.couponType==2">%</ng-container> :
          </b>
        </p>
        <div>
          {{order.couponValue | number : '1.2-2'}} €
        </div>
      </div>
      <div class="d-flex justify-content-between" *ngIf="order.fees>0">
        <p>
          <b>{{order.feesLabel}} :</b>
        </p>
        <div>
          {{order.fees | number : '1.2-2'}} €
        </div>
      </div>
    </div>
  </div>
  <div class="panel-footer">
    <!-- <ng-container *ngIf="elementsNbr>0"> -->
      <div class="d-flex justify-content-between">
        <p>
          <b>Total TTC :</b>
        </p>
        <p>
          <b>{{order.total | number : '1.2-2'}} €</b>
        </p>
      </div>
    <!-- </ng-container> -->
    <div class="row" *ngIf="showButton">
      <div class="com-md-12">
        <button (click)="checkoutEvent()" class="btn btn-ckeckout"
          [disabled]="order?.elements.length==0 && order?.menus.length==0">
          Valider la commande
        </button>
      </div>
    </div>
  </div>
</div>
<ng-template #template>
  <div class="modal-body text-center">
    <p>
      <i class="fa fa-exclamation-triangle fa-2 text-navy" aria-hidden="true"></i> Attention
    </p>
    <p>Vous êtes sur le point de modifier le mode de votre commande.</p>
    <p>Si vous continuez, votre panier sera automatiquement vidé. Continuer ?</p>
    <button type="button" class="btn btn-default mr-10" (click)="confirm()">OUI</button>
    <button type="button" class="btn btn-primary" (click)="decline()">NON</button>
  </div>
</ng-template>
<ng-template #template2>
  <div class="modal-body text-center">
    <p>
      <i class="fa fa-exclamation-triangle fa-2 text-navy" aria-hidden="true"></i>
    </p>
    <p>Montant minimum de livraison: {{amountMiniDelivery}} €, Voulez vous continue comme même?</p>
    <button type="button" class="btn btn-default mr-10" (click)="confirm2()">OUI</button>
    <button type="button" class="btn btn-primary" (click)="decline()">NON</button>
  </div>
</ng-template>